export default __webpack_public_path__ + "assets/images/background.8c359f.png";